// extracted by mini-css-extract-plugin
export default {"PageNavCreateNew":"PageNavCreateNew1XUjzfTo9j6G"};